import { Box } from "@mui/material";
import Header from "../../components/header/header";
import { brandingColors } from "../../components/utils";
import "./white-label.css";
import FooterComponent from "../../components/footer";
import GetDemoActionComponent from "../../components/get-demo-action/get-demo-action";
import { Link } from "react-router-dom";
import DocumentMeta from "react-document-meta";

export default function WhiteLabelPage(): JSX.Element {
  const meta = {
    title: "White Label | 123Skincare",
    canonical: "https://www.123skincare.pro/white-label",
  };

  return (
    <DocumentMeta {...meta}>
    <div className="white-label-page">
      <Header showLogo={false} />
      <Box className="main"
        sx={{
        width: "100%",
        color: brandingColors["grey-font"],
        margin: "0 auto",
        padding: 0,
        }}>
          <div className="container">
            <div className="wrapper">
              <Box className="middle">
                <Box className="site-logo">
                <Link to="/">
                  <img
                    alt=""
                    src="/assets/site-logo.png"
                    height="70px"
                    style={{ objectFit: "cover" }}
                  />
                </Link>
                </Box>

                <Box className="description">
                  <Box className="subtitle">
                    <img src="/assets/123skincare-logo-background.svg"/>
                    <span>Unlock new product search opportunities</span>
                  </Box>
                </Box>
                <Box className="white padding">
                  <Box>
                    <h1>Add AI search to your site?</h1>
                  </Box>
                  <Box className="flex space-between">
                    <h4>We provide technology and beauty expertise</h4>
                    <GetDemoActionComponent className="btn-primary" />
                  </Box>
                </Box>
              </Box>

              <Box className="bottom flex space-between">
                <Box className="left">
                  <h2>AI Product Search</h2>
                  <h3 className="italic">We offer both monthly subscriptions and custom projects</h3>
                  <p>Access our technology through a subscription model starting at 50 euros per month, or opt for a custom approach. We specialize in partnering with skincare and beauty marketplaces.</p>
                  <GetDemoActionComponent className="btn-secondary" />
                </Box>
                <Box className="right padding">
                  <div className="smartphone">
                    <div className="content">
                      {/*<iframe src="https://123skincare-media.s3.eu-west-1.amazonaws.com/123skincare-demo-mobile.mp4"/>*/}
                      <video controls autoPlay muted loop>
                        <source src="https://123skincare-media.s3.eu-west-1.amazonaws.com/123skincare-demo-mobile.mp4" type="video/mp4" />
                      </video> 
                    </div>
                  </div>
                </Box>
              </Box>

              <FooterComponent />
            </div>
          </div>
      </Box>
    </div>
    </DocumentMeta>
  )
}